import axios from '@/axios';

/**
 * 고객 대리 로그인 토큰 발급
 * @param {Object} payload
 * @param {string} payload.mobile 대상 고객 전화번호
 * @param {string} payload.reason 대리 로그인 사유 (감사 로그용)
 * @returns {Promise<{ token: string, customer: { _id, name, mobile }, expiresAt: string }>}
 */
export const impersonateCustomer = async ({ mobile, reason }) => {
  const response = await axios.post('/admin/customers/impersonate', {
    mobile,
    reason,
  });
  return response.data;
};
